import { Injector } from "@angular/core";
import { GridActionHandlerBase } from "../../../../../../components/common/grid-base/actions/grid-action-handler-base";
import { WorkspaceBase } from "../../../../../../components/common/workspace-base/workspace-base";
import { AppStorageService } from "../../../../../../services/app-storage.service";

/**
 * Assigns/unassigns properties from/to portfolio
 */
export class SearchPropertiesLinkToPortfolioGridActionHandler extends GridActionHandlerBase {
  /**
   * Constructor
   * @param injector Ihe Angular injector
   * @param workspace The workspace in which the action should be performed
   * @param topic Topic (subscribeEvent topic)
   */
  constructor(injector: Injector, workspace: WorkspaceBase, topic: string, private appStorage: AppStorageService) {
    super(injector, workspace, topic);
  }

  /**
  * Handles an event
  * @param _payload The (untyped) payload. Can also be a callback function
  */
  public handle(_payload: any): void {
    const appStorage = this.appStorage;
    const portfolio = appStorage.getSelectedPortfolio();
    const project = appStorage.getSelectedProject();
    if (portfolio || project) {
      this.searchForPropertiesAndLink();
    } else {
      this.eventBus.broadcastEvent("openConfirmDialog", {
        success: () => {
          //Nothing
        }
      }, 'errorMessage.confirmDialog.chooseProjectOrPortfolio');
    }
  }

  /**
   * Searches for properties and links these
   */
  private searchForPropertiesAndLink() {
    this.eventBus.broadcastEvent("openAssignPropertyDialog", {
      action: (selectedProperty: any) => {
        if (selectedProperty) {
          const appStorage = this.appStorage;
          const portfolio = appStorage.getSelectedPortfolio();
          const project = appStorage.getSelectedProject();

          let projectId = 0;
          let portfolioId = 0;

          if (portfolio) {
            portfolioId = portfolio.Oid;
          } else if (project) {
            projectId = project.Oid;
          }

          const payloads = [];
          const propertyId: number = selectedProperty.Oid;
          const payload = this.getAssignToPortfolioPayload(true, propertyId, portfolioId, projectId);
          payloads.push(payload);

          this.eventBus.broadcastEvent('property:assignPropertiesToPortolio', payloads);
        }
      }
    });
  }

  /**
   * Ges the payload data for assigning a property to a portfolio
   * @param assign
   * @param propertyId
   * @param portfolioId
   * @param projectid
   * @returns
   */
  private getAssignToPortfolioPayload(assign: boolean, propertyId: number, portfolioId: number, projectid: number) {
    const payload = {
      propertyId: propertyId,
      portfolioId: assign ? (portfolioId || 0) : -(portfolioId || 0),
      projectId: projectid
    };

    return payload;
  }
}
